import {
    CHANGE_PAYMENT_TYPE_START,
    CHANGE_PAYMENT_TYPE_SUCCESS,
    CHANGE_PAYMENT_TYPE_ERROR
} from '../../constants';
import showToaster from '../../helpers/toastrMessgaes/showToaster';
import { changePaymentType as mutation, getBookingById as query } from '../../lib/graphql';

export function changePaymentType({ bookingId, paymentType }) {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: CHANGE_PAYMENT_TYPE_START,
            });

            const { data } = await client.mutate({
                mutation,
                variables: {
                    bookingId,
                    paymentType
                },
                refetchQueries: [
                    {
                        query,
                        variables: {
                            bookingId
                        },
                    }
                ]
            });

            if (data?.changePaymentType?.status === 200) {
                dispatch({
                    type: CHANGE_PAYMENT_TYPE_SUCCESS,
                });
            } else {
                showToaster({ messageId: 'catchMessage', requestContent:  data?.changePaymentType?.errorMessage , toasterType: 'error' });
                dispatch({
                    type: CHANGE_PAYMENT_TYPE_ERROR,
                });
            }
        } catch (error) {
            dispatch({
                type: CHANGE_PAYMENT_TYPE_ERROR,
            });
            return {
                status: '400'
            };
        }
        return {
            status: '200'
        };
    };
}